import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Tooltip,
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Table from "../tables/table";
import CreatePartidaDialog from "./CreatePartidaDialog";
import CreatePartidaSubcategoryDialog from "./CreatePartidaSubcategoryDialog";
import PartidaCategoryTree from "../partidas/PartidaCategoryTree";
import "./PartidaTableDialog.scss";

// function getData(partidas) {
// 	let data = [];

// 	for (let i = 0; i < partidas.length; ++i) {
// 		const elem = {};
// 		const partida = partidas[i];

// 		elem.referencia = partida?.referencia;
// 		elem.descripcion = partida?.descripcion;
// 		elem.categoria = partida?.categoria?.descripcion;
// 		elem.id = partida?.id;

// 		data = data.concat(elem);
// 	}

// 	return data;
// }

function getData(partidas) {
	return (partidas || [])
		.filter((partida) => partida && partida.id != null)
		.map((partida) => ({
			id: partida.id,
			referencia: partida?.referencia || "",
			descripcion: partida?.descripcion || "",
			categoria: (partida?.categorias?.length
				? partida.categorias
				: [partida?.categoria].filter(Boolean)
			)
				.map((categoria) => categoria?.descripcion)
				.filter(Boolean)
				.join(", "),
			cliente: partida?.cliente_nombre || "General",
			especifica: Boolean(partida?.cliente_id),
			activo: partida?.activo,
			active: partida?.active,
		}));
}
const PartidaTableDialog = (props) => {
	const { title, open, setOpen, data, onSelect, rootCategory, categories = [] } = props;

	const [openCreatePartidaDialog, setOpenCreatePartidaDialog] = useState(
		false
	);
	const [selectedSubcategoryId, setSelectedSubcategoryId] = useState("");
	const [expandedCategoryIds, setExpandedCategoryIds] = useState(new Set());
	const [openCreateSubcategoryDialog, setOpenCreateSubcategoryDialog] = useState(false);
	const [createdSubcategories, setCreatedSubcategories] = useState([]);

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	useEffect(() => {
		if (open) {
			setSelectedSubcategoryId("");
			setExpandedCategoryIds(new Set(rootCategory?.id ? [rootCategory.id] : []));
		}
	}, [open, rootCategory?.id]);

	function buttonFormatter(cell) {
		return (
			<>
				<Tooltip title="Seleccionar">
					<Button
						style={{ minWidth: 30, width: 30, height: 30, padding: 0, margin: 0 }}
						size="small"
						onClick={(e) => {
							setOpen(false);
							onSelect(cell);
						}}
					>
						<AddCircle />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{
			dataField: "referencia",
			text: "Referencia",
			sort: true,
			headerStyle: { width: "26%" },
		},
		{
			dataField: "descripcion",
			text: "Descripción",
			sort: true,
			headerStyle: { width: "53%" },
		},
		{
			dataField: "categoria",
			text: "Categoría",
			sort: true,
			headerStyle: { width: "8%" },
			headerAlign: "right",
			align: "right",
		},
		{
			dataField: "cliente",
			text: "Cliente",
			headerStyle: { width: "8%" },
			headerAlign: "right",
			align: "right",
			formatter: (cell, row) =>
				row.especifica ? (
					<span className="badge badge-success">Específica: {cell}</span>
				) : (
					cell
				),
		},
		{
			dataField: "id",
			text: "",
			formatter: buttonFormatter,
			headerStyle: { width: "5%" },
			align: "right",
		},
	];

	const allCategories = [
		...categories,
		...createdSubcategories.filter((created) => !categories.some((category) => category.id === created.id)),
	];
	const visibleData = selectedSubcategoryId
		? (data || []).filter((partida) => (partida?.categorias?.length ? partida.categorias : [partida?.categoria]).some(
			(category) => String(category?.id || "").toLowerCase() === String(selectedSubcategoryId).toLowerCase()
		))
		: data;

	return (
		<>
			<Dialog
				fullWidth={true}
				maxWidth="xl"
				open={open}
				onClose={() => {
					setOpen(false);
				}}
				aria-labelledby="table-dialog"
				className="backdrop partida-picker-dialog"
			>
				<DialogTitle id="table-dialog">
					<div className="d-flex justify-content-between">
						{title ||  "Partidas"}
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => {
								setOpenCreatePartidaDialog(true);
							}}
						>
							Añadir nueva
						</button>
					</div>
				</DialogTitle>
				<DialogContent className="partida-picker-content">
					<div className="partida-picker-layout">
						{rootCategory && (
							<PartidaCategoryTree
								className="partida-picker-category-panel"
								rootCategories={[rootCategory]}
								categories={allCategories}
								selectedRoot={rootCategory}
								selectedSubcategoryId={selectedSubcategoryId}
								expandedCategoryIds={expandedCategoryIds}
								onSelectRoot={(category) => {
									setSelectedSubcategoryId("");
									setExpandedCategoryIds((current) => new Set(current).add(category.id));
								}}
								onSelectSubcategory={(category, child) => setSelectedSubcategoryId(child.id)}
								onToggleCategory={(categoryId) => setExpandedCategoryIds((current) => {
									const next = new Set(current);
									if (next.has(categoryId)) next.delete(categoryId);
									else next.add(categoryId);
									return next;
								})}
								onCreateSubcategory={() => setOpenCreateSubcategoryDialog(true)}
							/>
						)}
						<div className="partida-picker-results">
							{!visibleData?.length && <p>No hay partidas disponibles.</p>}
							<Table
								persistPageInUrl={false}
								pageResetKey={selectedSubcategoryId}
								data={getData(visibleData)}
								columns={columns}
								rowStyle={(row) =>
									row.especifica ? { backgroundColor: "#e8f8ee" } : {}
								}
							/>
						</div>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						className="mr-2"
						onClick={() => {
							setOpen(false);
						}}
						variant="outlined"
					>
						Cancelar
					</Button>
					<br />
				</DialogActions>
			</Dialog>
			<CreatePartidaDialog
				open={openCreatePartidaDialog}
				setOpen={setOpenCreatePartidaDialog}
				defaultCustomerId={props.defaultCustomerId}
				defaultRootCategoryId={rootCategory?.id}
				defaultSubcategoryId={selectedSubcategoryId || null}
				onSave={(partidaId) => {
					onSelect(partidaId);
					setOpen(false);
				}}
			/>
			<CreatePartidaSubcategoryDialog
				open={openCreateSubcategoryDialog}
				setOpen={setOpenCreateSubcategoryDialog}
				parentCategory={rootCategory}
				onCreated={(subcategory) => {
					setCreatedSubcategories((current) => [...current, subcategory]);
					setExpandedCategoryIds((current) => new Set(current).add(rootCategory.id));
					setSelectedSubcategoryId(subcategory.id);
				}}
			/>
		</>
	);
};
export default PartidaTableDialog;
